import {
  DeclarationStatus,
  HarbourDuesDeclarationStatus,
  TaskMessageStatus
} from "@portbase/bezoekschip-service-typescriptmodels";

export class NewPortvisitUtils {

  static declarationStatusToTaskMessageStatus = (status: DeclarationStatus): TaskMessageStatus => {
    switch (status) {
      case DeclarationStatus.DECLARED:
        return TaskMessageStatus.PENDING;
      case DeclarationStatus.ACCEPTED:
        return TaskMessageStatus.ACCEPTED;
      case DeclarationStatus.REJECTED:
        return TaskMessageStatus.REJECTED;
      default:
        return TaskMessageStatus.UNKNOWN;
    }
  }

  static taskMessageStatusToDeclarationStatus = (status: TaskMessageStatus): DeclarationStatus => {
    switch (status) {
      case TaskMessageStatus.PENDING:
        return DeclarationStatus.DECLARED;
      case TaskMessageStatus.ACCEPTED:
        return DeclarationStatus.ACCEPTED;
      case TaskMessageStatus.REJECTED:
        return DeclarationStatus.REJECTED;
      default:
          return null;
    }
  }

  // BSHD-342: the harbour dues declaration status is HarbourDuesDeclarationStatus (DECLARED/ACCEPTED/
  // REJECTED/ERROR), distinct from the generic DeclarationStatus. These mirror the generic conversions.
  static harbourDuesDeclarationStatusToTaskMessageStatus = (status: HarbourDuesDeclarationStatus): TaskMessageStatus => {
    switch (status) {
      case HarbourDuesDeclarationStatus.DECLARED:
        return TaskMessageStatus.PENDING;
      case HarbourDuesDeclarationStatus.ACCEPTED:
        return TaskMessageStatus.ACCEPTED;
      case HarbourDuesDeclarationStatus.REJECTED:
        return TaskMessageStatus.REJECTED;
      case HarbourDuesDeclarationStatus.ERROR:
        return TaskMessageStatus.ERROR;
      default:
        return TaskMessageStatus.UNKNOWN;
    }
  }

  static taskMessageStatusToHarbourDuesDeclarationStatus = (status: TaskMessageStatus): HarbourDuesDeclarationStatus => {
    switch (status) {
      case TaskMessageStatus.PENDING:
        return HarbourDuesDeclarationStatus.DECLARED;
      case TaskMessageStatus.ACCEPTED:
        return HarbourDuesDeclarationStatus.ACCEPTED;
      case TaskMessageStatus.REJECTED:
        return HarbourDuesDeclarationStatus.REJECTED;
      case TaskMessageStatus.ERROR:
        return HarbourDuesDeclarationStatus.ERROR;
      default:
        return null;
    }
  }

  // Maps the harbour dues status onto the generic DeclarationStatus for the generic visit-status
  // indicator (app-declaration-status). The three shared values map 1:1; the harbour-dues-only
  // ERROR has no generic representation and maps to null (the indicator then shows no status).
  static harbourDuesDeclarationStatusToDeclarationStatus = (status: HarbourDuesDeclarationStatus): DeclarationStatus => {
    switch (status) {
      case HarbourDuesDeclarationStatus.DECLARED:
        return DeclarationStatus.DECLARED;
      case HarbourDuesDeclarationStatus.ACCEPTED:
        return DeclarationStatus.ACCEPTED;
      case HarbourDuesDeclarationStatus.REJECTED:
        return DeclarationStatus.REJECTED;
      default:
        return null;
    }
  }

}
